import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleUpSmall"><Path d="M10.0869 13.5003C9.23254 13.5003 8.77163 12.4981 9.32764 11.8495L11.2405 9.61776C11.6396 9.15215 12.3599 9.15215 12.759 9.61776L14.6719 11.8495C15.2279 12.4981 14.767 13.5003 13.9127 13.5003H10.0869Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
